import styled from "styled-components";

export const RequestContentWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: auto;

  .timeline-left-panel {
    width: 260px;
    padding: 10px 0px 0px 8px;
    border-right: 1px solid #f0f0f0;
    overflow: auto;
  }

  .timeline-item-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .timeline-item-top {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .timeline-item-middle {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .user-warp {
      display: flex;
      gap: 4px;
      align-items: center;
      flex-wrap: wrap;
    }

    .user-name {
      display: flex;
      gap: 4px;
      align-items: center;
    }
  }

  .timeline-item-bottom {
    color: #8c8c8c;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }

  .desc-label {
    width: 100px;
    text-align: right;
  }
`;
